import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SidebarActionCardProps {
    title: string;
    description: string;
    icon: ReactNode;
    onClick: () => void;
    disabled?: boolean;
    className?: string;
    children?: ReactNode;
}

export default function SidebarActionCard({
    title,
    description,
    icon,
    onClick,
    disabled = false,
    className,
    children,
}: SidebarActionCardProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={cn(
                'w-full rounded-2xl border-2 border-border p-4 text-left transition-all',
                disabled ? 'cursor-not-allowed bg-surface opacity-50' : 'hover:bg-surface',
                className,
            )}
        >
            <div className="flex items-start gap-4">
                <div className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-muted">
                    {icon}
                </div>
                <div className="flex-1">
                    <h3 className="font-semibold text-foreground">{title}</h3>
                    <p className="mt-1 text-sm text-muted-foreground">{description}</p>
                    {children}
                </div>
            </div>
        </button>
    );
}
